export default {
  steps: {
    setup_fee: 'Set up fee',
    business_info: 'Business info',
    create_preview: 'Create preview contract',
    preview: 'Preview contract',
    sign: 'Sign contract',
  },
  buttons: {
    next: 'Preview Contract',
    save_and_continue: 'Save & Continue',
    update: 'Update preview',
    cancel: 'Cancel current',
    skip: 'Skip contract creation',
  },
  create_preview: {
    header: 'Create preview contract',
    description: 'Enter the recipient details for the contract. You can still change them before sending.',
  },
  sign: {
    update_notice: 'In order to update the contract, cancel the current one and edit the details.',
  },
  toasts: {
    failed_to_save_changes: 'Failed to save changes',
  },
};
